// Mock Health Data
// Extracted from DesignPreview.tsx and other health-related components

export interface HealthMetrics {
  glucose: number;
  bloodPressure: {
    systolic: number;
    diastolic: number;
  };
  weight: number;
  heartRate: number;
}

export interface MedicationEntry {
  name: string;
  dosage: string;
  frequency: string;
  status: 'taken' | 'due' | 'missed';
}

export const mockHealthData: HealthMetrics = {
  glucose: 120,
  bloodPressure: { systolic: 120, diastolic: 80 },
  weight: 150,
  heartRate: 72
};

export const mockMedications: MedicationEntry[] = [
  { name: "Metformin", dosage: "500mg", frequency: "2x daily", status: "taken" },
  { name: "Lisinopril", dosage: "10mg", frequency: "1x daily", status: "due" },
  { name: "Aspirin", dosage: "81mg", frequency: "1x daily", status: "missed" }
]; 